import React, { useState } from 'react';

import { hasAppToken } from 'microsites/partner-linking/app-token';

import AuthRequired from 'pages/authentication/auth-required';

interface IProps {
  children: React.ReactNode;
  keepParams?: boolean;
}

/**
 * Auth gate for the partner-linking flow pages.
 *
 * When the TH app handed off a JWT (present in the URL hash on initiate, or in
 * sessionStorage after the OIDC round-trip) the browser has no TH Cognito
 * session, but the user is authenticated for this flow via the Bearer token.
 * In that case we render the flow directly and skip the `/signup` redirect.
 *
 * Otherwise (web-only entry, no token) we defer to the standard `AuthRequired`
 * gate, which requires a TH session and redirects to sign-up.
 *
 * The decision is locked at mount so clearing the token at the end of the flow
 * can't flip the gate into a stray sign-up redirect mid-navigation.
 */
export default function PartnerLinkingAuthGate({ children, keepParams = false }: IProps) {
  const [appTokenFlow] = useState(() => hasAppToken());

  if (appTokenFlow) {
    return <>{children}</>;
  }

  return <AuthRequired keepParams={keepParams}>{children}</AuthRequired>;
}
